import * as React from "react";

export const TrashIcon: React.SFC = ({}) => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 14 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M1,16.5925926 C1,17.7333333 1.9,18.6666667 3,18.6666667 L11,18.6666667 C12.1,18.6666667 13,17.7333333 13,16.5925926 L13,4.14814815 L1,4.14814815 L1,16.5925926 Z M3,6.22222222 L11,6.22222222 L11,16.5925926 L3,16.5925926 L3,6.22222222 Z M10.5,1.03703704 L9.5,0 L4.5,0 L3.5,1.03703704 L0,1.03703704 L0,3.11111111 L14,3.11111111 L14,1.03703704 L10.5,1.03703704 Z"
        id="path-trash"
      />
    </defs>
    <g
      id="Mapping-+-Rules-v2"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Hover---Remove-Child-Account"
        transform="translate(-646.000000, -477.000000)"
      >
        <g id="Icon/Remove" transform="translate(639.000000, 473.000000)">
          <g>
            <polygon id="Path" points="0 0 28 0 28 28 0 28" />
            <g id="icon-color" transform="translate(7.000000, 4.666667)">
              <g>
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-trash" />
                </mask>
                <use
                  id="Mask"
                  fill="#747474"
                  fillRule="nonzero"
                  xlinkHref="#path-trash"
                />
                <g id="Color-/-Dark-Gray" mask="url(#mask-2)">
                  <g
                    transform="translate(-5.000000, -3.111111)"
                    id="Rectangle-2"
                  >
                    <rect x="0" y="0" width="24" height="25" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/documentUpload/TrashIcon.tsx